import { LocalStorageKey } from "@/modules/local-storage/constants";

/**
 * Reads the per-device preference at playback time so every renderer sees the
 * latest choice, including Electron's separate floating-agent window.
 */
export const readMemAgentNewMessageSoundEnabled = (): boolean => {
  try {
    return localStorage.getItem(LocalStorageKey.MemAgentNewMessageSoundEnabled) !== "false";
  } catch (_error) {
    return true;
  }
};

export const writeMemAgentNewMessageSoundEnabled = (enabled: boolean): void => {
  try {
    localStorage.setItem(LocalStorageKey.MemAgentNewMessageSoundEnabled, String(enabled));
  } catch (_error) {
    // Persistence is best-effort; playback defaults to enabled when storage is unavailable.
  }
};
